import property from 'lodash/fp/property';

import { Author } from '../../types';
import { AuthorSlice } from './authorFilterSlice';

export const getAuthor = (state: AuthorSlice): Author | undefined => property('author', state);

export const isLoadingAuthor = (state: AuthorSlice): boolean => property('isLoading', state);
